import { ofType } from '@ngrx/effects';
import { filter } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings, Settings } from '../../app.settings';
import { User } from './user.model';
import { UserServiceService } from 'src/app/services/user-service.service';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ToastrService } from 'ngx-toastr';
import { HostService } from 'src/app/services/host.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { UserMailComponent } from './user-mail/user-mail.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UsersComponent implements OnInit, OnDestroy {
    public users:any =[];
    public usersAll:any =[];
    public searchText: string = '';
    public page:any;
    public id:any;
    public settings: Settings;
    public maxSize:number = 5;
    public autoHide:boolean = true;
    public userIn: any;
    public typeGrid:string="grid";
    displayedColumns: string[] = [
        "image",
        "etat",
        "name",
        "email",
        "phone",
        "location",
        "date",
        "role",
        "actions",
      ];
    dataSource!: MatTableDataSource<any>;
    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort!: MatSort;

    MatSlideToggleChange = {source: MatSlideToggle, checked: true}

    //Subscripption
    changeProfilSubscription: Subscription;

    //boolean
    profilChanged: boolean = false;

    constructor(public appSettings:AppSettings, 
                public dialog: MatDialog,
                private toastr: ToastrService,
                private service:UserServiceService,
                private authService:AuthService,
                public userService: UserServiceService,
                public hostService: HostService,
                public router: Router){
        this.settings = this.appSettings.settings; 
    }

    ngOnInit() {
        const storageAuth = localStorage.getItem("user");
        if (storageAuth) {
        this.userIn = JSON.parse(storageAuth);
        }
        this.getUsers();         
    }

    onChange($event: MatSlideToggleChange, id: number) {
        console.log(id);
        let obj = {
            user: $event.checked?1:0,
            idSup:id
        }
        console.log(obj);
        this.id=id;
        if( $event.checked == true){
            this.service.updateStatusSuper( obj).subscribe((data:any)=>{
                this.toastr.error('utilisateur bloquer')
                if(id == this.userIn.id)
                {
                    this.authService.logout();
                }                   

            }) 
        }else{
            this.service.updateStatusSuper( obj).subscribe((data:any)=>{
                this.toastr.success('utilisateur Débloquer')

            }) 
        }
    
    }
    public getUsers(): void {
        this.service.getUser().subscribe((reponse:any)=>{
            this.usersAll = this.users = []
            this.usersAll = this.users= reponse;
            this.dataSource = new MatTableDataSource<any>(this.users);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
    })
    }

    public create(data:any){
        this.service.CreateUser(this.users).subscribe((data:any)=>{

        })
    } 
    public updateUser(data:any){
        let obj = {
            user:this.users
        }
        this.service.updateSuper( obj).subscribe((data:any)=>{
        })  
    }
    public deleteUser(id:number){

        let obj = {
            id:id
        }
       this.service.delete(id).subscribe(user =>{
        this.getUsers();
        if(id == this.userIn.id)
        {
            this.authService.logout();
        }
       } );
    }

    public onPageChanged(event:any){
        this.page = event;
        this.getUsers();
        window.scrollTo(0,0);
    }

    public fliterDataSource(event:Event)
    {
        console.log(this.typeGrid);
        let filterValue= (event.target as HTMLInputElement).value;
        if(this.typeGrid=="grid")
        {
            if(filterValue ==="")
            {
                this.users = this.usersAll;
            }else{
                this.users =  this.filterByValue(this.usersAll,filterValue);
            }
        }
        else{
            this.dataSource.filter = filterValue.trim().toLowerCase();
        }
    }

    filterByValue(array:[],chaine:string){
        return array.filter((o) => Object.keys(o).some(k=>String(o[k]).toLowerCase().includes(chaine.toLocaleLowerCase())))
    }


    public changeProfil(value: string, id: number, text: string) {

        let currentUser = this.usersAll?.find((user: any) => user.id == id);
        
        console.log(value, id, currentUser);

        if(currentUser.user_profil == value) {

            this.toastr.error('Veuillez séléctionner un autre profil');

        } else {

            let obj = {
                'id': id,
                'profil': value
            };
    
            this.changeProfilSubscription = this.userService.changeProfil(obj).subscribe((response: any) => {
                console.log(response);
    
                this.toastr.success("Le profil de l'utilisateur "+currentUser.user_name+" "+currentUser.user_surname+" est passé à "+text);

                this.getUsers();

                this.profilChanged = true;
    
            })

        }
    }

    public detailOfUser(id: number) {
        this.router.navigate(["admin/users/view"], {queryParams: { id: id }});
    }

    public openUserDialog(user:User | null){
        let dialogRef = this.dialog.open(UserDialogComponent, {
            data: user
        });

        dialogRef.afterClosed().subscribe(user => {
            if(user){
               this.updateUser(user) 
            }
        });
    }

    public sendEmailOfUsers(dataUser:{[key:string]:any}|null):void
    {

        let data:{[key:string]:any} ={
            user:dataUser,
            users:this.usersAll.filter((elt:{[key:string]:any})=>elt.email !=null || elt.email != undefined)
        }
        let dialogRef = this.dialog.open(UserMailComponent, {
            data: data,
            width: '780px',
            height:'630px',
        });

               
    }


    ngOnDestroy(): void {
        if(this.profilChanged) {
            this.changeProfilSubscription.unsubscribe();
        }
    }
}